import { Box } from "@mui/material";
import WageContent from "./components/WageContent";

const wageConnectPage = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        mt: { xs: 4, sm: 6 },
        mx: "auto",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <WageContent />
    </Box>
  );
};

export default wageConnectPage;
